import { gql } from '@apollo/client';
export default gql`
  query getVacations(
    $start: Date
    $end: Date
    $active: Boolean
    $departmentId: String
    $employeeId: String
  ) {
    getVacations(
      start: $start
      end: $end
      active: $active
      departmentId: $departmentId
      employeeId: $employeeId
    ) {
      ok
      error
      count
      data {
        _id
        branch
        time
        title
        desc
        status
        startDate
        endDate

        departmentId
        departmentName
        departmentNameAr

        employeeId
        employeeName
        employeeNameAr

        userId
        note

        createdAt
        updatedAt
      }
    }
  }
`;
